export default "__VITE_ASSET__DskIEb9X__"